<template>
  <mdb-card>
    <mdb-card-header class="pt-4 indigo">
      <mdb-card-title class="text-white"
        ><strong>{{
          $t("import_surrogates_header")
        }}</strong></mdb-card-title
      >
    </mdb-card-header>
    <mdb-card-body>
      <mdb-row>
        <mdb-col md="12">
          <mdb-file-input
            ref="fileInput"
            sm
            @getValue="getFileInputValue"
            floating
            icon="paperclip"
            gradient="blue"
            :textFieldTitle="$t('import_surrogates_file_input')"
          />
        </mdb-col>
        <mdb-col md="6">
            <UnionMemberSelection
              :defaultSelection="String(unionmember)"
              v-on:unionmemberid="setUnionMemberId"
            />
        </mdb-col>
        <mdb-col md="6">
          <SurrogateNameSelection
              :defaultSelection="String(surrogatename)"
              v-on:surrogatename="setSurrogateName"
            />
        </mdb-col>
        <mdb-row>
        <mdb-col>
          <mdb-btn
            v-on:click="importSurrogates"
            color="indigo"
            class="white-text"
            icon="paper-plane"
            >{{ $t("load") }}</mdb-btn
          >
        </mdb-col>
        </mdb-row>
      </mdb-row>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbFileInput,
  mdbInputMask,
} from "mdbvue";

import UnionMemberSelection from "@/components/UnionMemberSelection.vue";
import SurrogateNameSelection from "@/components/SurrogateNameSelection.vue";

export default {
  name: "ImportSurrogates",
  components: {
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbFileInput,
    UnionMemberSelection,
    SurrogateNameSelection,
  },
  directives: {
    mdbInputMask,
  },
  data() {
    return {
      unionmember: "",
      surrogatename: "",
      rawFile: null,
      name: "",
      postData: {},
      importedProductCodes: [],
      importSurrogatesPath: "/1.0/front/surrogateimport/import",
    };
  },
  methods: {
    setUnionMemberId(val) {
      this.unionmember = val;
    },
    setSurrogateName(val) {
      this.surrogatename = val;
    } ,
    getFileInputValue(val) {
    if (!val || val.length === 0) return;
    this.rawFile = val[0]; // File object — used in FormData
    },
    checkInputs() {
      if (this.unionmember !== "" && this.rawFile) return true;
      else return false;
    },
    getIds(advertisementId, benefitId){
      this.advertisementId = advertisementId;
      this.benefitId = benefitId;
    },
    importSurrogates() {
      if (!this.checkInputs()) {
        this.$notify.error({
          message: this.$t("import_surrogates_check_input"),
          position: "top right",
          timeOut: this.$store.state.notifytimeoutshort,
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", this.rawFile); // store val[0] as this.rawFile
      formData.append("unionmember", this.unionmember);
      formData.append("surrogatename", this.surrogatename);
      this.$http
        .post(this.importSurrogatesPath, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("import_surrogates_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("import_surrogates_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
  mounted() {
    this.$refs.fileInput.$refs.fileInput.accept = ".csv";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
